export default __webpack_public_path__ + "static/media/profile-placeholder.2e4ef16d.png";